module.exports = __webpack_public_path__ + "media/img/corporate/cover2-85aa4065f92ce375bd0855b2a110f60d.png";